import {ErrorPriority} from '../../enums/ErrorPriority';
import {ErrorType} from '../../enums/ErrorType';

export class ErrorDetailPreview {
    id: string;
    isSolved: boolean;
    priority: ErrorPriority;
    content: string;
    firstOccurred: Date;
    lastOccurred: Date;
    errorType: ErrorType;

    constructor(id: string, isSolved: boolean, priority: ErrorPriority, content: string, firstOccurred: string, lastOccurred: string, errorType: ErrorType) {
        this.id = id;
        this.isSolved = isSolved;
        this.priority = priority;
        this.content = content;
        this.firstOccurred = new Date(firstOccurred);
        this.lastOccurred = new Date(lastOccurred);
        this.errorType = errorType;
    }

    public get firstOccurredAsString(): string {
        const smallest = this.firstOccurred <= this.lastOccurred ? this.firstOccurred : this.lastOccurred; // TODO vanwege een bug met createdAt op een error in de API, deze check een maand laten staan, daarna mag firstOccured altijd worden getoond
        return smallest.toLocaleString();
    }

    public get lastOccurredAsString(): string {
        return this.lastOccurred.toLocaleString();
    }

    public getSummarizedContent(maxLenght: number): string {
        return this.content.length > maxLenght ? this.content.substring(0, maxLenght) + "..." : this.content;
    }
}
